import gql from 'graphql-tag';

export const getSubPlanById = gql`
subscription getSubPlanById($id: uuid!){
    subscription_plans_by_pk(id:$id){
    id
    updated_at
    name
    coming_soon 
    display_price
    price_in_aud
    price_in_usd
    tenure_in_days
    tenure_type
    terms_and_conditions
    type
    plan_type
    description
    benefits
    stripe_product_id
    stripe_price_id
    monthy_price
    yearly_price
  }
}
`;

export const getSubPlan = gql`
subscription getSubPlan{
    subscription_plans(where: {plan_type: {_eq: "REGULAR"}, plan_status:{_eq:"ACTIVE"}}){
    id
    updated_at
    name
    coming_soon
    display_price
    price_in_aud
    price_in_usd
    tenure_in_days
    tenure_type
    terms_and_conditions
    type
    description
    benefits
    plan_type
    monthy_price
    yearly_price
    plan_status
  }
}
`;
